import React from 'react';
import { getDiagnosticPrompt } from './OwnerDiagnosticCopy';

class OwnerDiagnosticQuestion extends React.Component {
  componentDidMount() {
    if (this.headingRef) {
      this.headingRef.focus();
    }
  }

  componentDidUpdate() {
    if (this.headingRef) {
      this.headingRef.focus();
    }
  }

  render() {
    const { sectionTitle, indexWithinSection, value, onSelect, onBack, saving, index } = this.props;
    const options = [1, 2, 3, 4, 5, 6];
    const prompt = getDiagnosticPrompt(index);

    return (
      <div className="flex justify-center bg-succession-surface px-4 pt-2 pb-6">
        <div className="w-full max-w-3xl">
          <div className="mb-4">
            <button
              type="button"
              onClick={onBack}
              className="text-succession-primary hover:underline"
              aria-label="Go back"
            >
              ← Back
            </button>
          </div>
          <h1
            className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2 focus:outline-none"
            tabIndex="-1"
            ref={(el) => (this.headingRef = el)}
          >
            {sectionTitle}
          </h1>
          <p className="text-succession-muted mb-2">Question {indexWithinSection} of 6</p>
          <p className="text-xl md:text-2xl text-succession-foreground mb-4">{prompt}</p>

          <div className="grid grid-cols-6 gap-4">
            {options.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`h-24 md:h-28 rounded-lg border-2 transition-all focus:outline-none focus:ring-2 focus:ring-succession-primary ${
                  value === opt
                    ? 'bg-succession-primary text-white border-succession-primary'
                    : 'bg-white text-succession-foreground border-succession-border hover:border-succession-primary'
                }`}
                aria-pressed={value === opt}
                onClick={() => onSelect(opt)}
                disabled={saving}
              >
                <span className="text-xl font-bold">{opt}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default OwnerDiagnosticQuestion;


